import { Info, TriangleAlert } from 'lucide-react'

import { Tabs, TabsContent } from '@fortem-monorepo/react-ui'

import { MarketSummaryDisplayControls } from '@/pages/instruments/market-summary/components/MarketSummaryDisplayControls'
import { MarketSummaryDisplayInstrumentsTab } from '@/pages/instruments/market-summary/components/MarketSummaryDisplayInstrumentsTab'
import { MarketSummaryMetricsTab } from '@/pages/instruments/market-summary/components/MarketSummaryMetricsTab'
import { MarketSummaryReportControls } from '@/pages/instruments/market-summary/components/MarketSummaryReportControls'
import { MarketSummaryReportTab } from '@/pages/instruments/market-summary/components/MarketSummaryReportTab'
import {
  DISPLAY_TABS,
  DisplayTab,
  useMarketSummaryContext,
} from '@/pages/instruments/market-summary/market-summary-context'

export interface MarketSummaryDisplaysTabProps {}

export const MarketSummaryDisplaysTab: React.FC<MarketSummaryDisplaysTabProps> = ({}) => {
  const { viewsQuery, viewSelected, displayTab, selectDisplayTab } = useMarketSummaryContext()

  return (
    <Tabs
      className={'gap-0 h-full w-full flex-1'}
      value={displayTab}
      onValueChange={(val) => selectDisplayTab(val as DisplayTab)}
    >
      <MarketSummaryDisplayControls />
      {viewSelected && displayTab === DISPLAY_TABS.REPORT && <MarketSummaryReportControls />}
      {!viewSelected ? (
        <div className="flex flex-1 w-full h-full justify-center items-center">
          <div className={'border bg-sidebar p-8 rounded-md shadow-sm space-y-4 flex items-center flex-col'}>
            {viewsQuery.error ? (
              <>
                <TriangleAlert className={'text-red-500'} />
                <span className={'text-muted-foreground'}>{viewsQuery.error.message}</span>
              </>
            ) : (
              <>
                <Info className={'text-blue-400'} />
                <span className={'text-muted-foreground'}>Select a view at the top of the page to get started.</span>
              </>
            )}
          </div>
        </div>
      ) : (
        <>
          <TabsContent value={DISPLAY_TABS.REPORT} className={'w-full'}>
            <MarketSummaryReportTab />
          </TabsContent>
          <TabsContent value={DISPLAY_TABS.METRICS}>
            <MarketSummaryMetricsTab />
          </TabsContent>
          <TabsContent value={DISPLAY_TABS.INSTRUMENTS}>
            <MarketSummaryDisplayInstrumentsTab />
          </TabsContent>
        </>
      )}
    </Tabs>
  )
}
